"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const react_router_1 = require("react-router");
const Button_1 = __importDefault(require("../input/Button"));
const FormErrors_1 = __importDefault(require("../pageParts/FormErrors"));
const Auth_1 = require("../../actions/Auth");
const SimpleMessage = ({ message }) => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    return (react_1.default.createElement("div", { className: "apptr__form apptr__form-auth apptr__form__label-standalone" },
        react_1.default.createElement("p", { className: "apptr__form__label-standalone" }, t(message)),
        react_1.default.createElement("div", { className: "apptr__footer-link-container" },
            react_1.default.createElement(react_router_1.Link, { className: "apptr__footer-link _oblique", to: "/login" }, t('auth:BackToLoginPage')))));
};
const ResetPasswordPage = () => {
    const { t } = (0, react_i18next_1.useTranslation)('auth');
    const dispatch = (0, react_redux_1.useDispatch)();
    const { token } = (0, react_router_1.useParams)();
    const submitButtonRef = react_1.default.useRef(null);
    const status = (0, react_redux_1.useSelector)((state) => state.auth.status);
    const [formState, setFormState] = react_1.default.useState({
        password: '',
        passwordConfirmation: '',
        error: undefined
    });
    react_1.default.useEffect(() => {
        if (token) {
            dispatch((0, Auth_1.startResetPassword)({ token }));
        }
    }, [token, dispatch]);
    react_1.default.useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.which === 13 && e.target instanceof HTMLElement && e.target.tagName.toLowerCase() !== 'textarea') {
                e.preventDefault();
            }
        };
        document.addEventListener('keydown', handleKeyPress);
        return () => document.removeEventListener('keydown', handleKeyPress);
    }, []);
    const validateForm = () => {
        if (!formState.password) {
            return t('auth:missingPassword');
        }
        if (formState.password !== formState.passwordConfirmation) {
            return t('auth:passwordsDoNotMatch');
        }
        if (formState.password.length < 8) {
            return t('auth:passwordMustHaveAtLeastNCharacters', { n: 8 });
        }
        return undefined;
    };
    const handleSubmit = () => {
        const error = validateForm();
        if (error) {
            setFormState((prev) => (Object.assign(Object.assign({}, prev), { error })));
            return;
        }
        setFormState((prev) => (Object.assign(Object.assign({}, prev), { error: undefined })));
        dispatch((0, Auth_1.startResetPassword)({
            token,
            password: formState.password
        }));
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormState((prev) => (Object.assign(Object.assign({}, prev), { [name]: value })));
    };
    const getStatusMessage = () => {
        switch (status) {
            case 'Expired':
                return 'auth:ResetTokenExpired';
            case 'NotFound':
                return 'auth:ResetTokenNotFound';
            case 'PasswordChanged':
                return 'auth:PasswordChangedSuccessfully';
            case 'Error':
                return 'auth:ResetTokenError';
            default:
                return undefined;
        }
    };
    const buttonProps = {
        isVisible: true,
        align: 'center',
        onClick: handleSubmit
    };
    const statusMessage = getStatusMessage();
    if (statusMessage) {
        return react_1.default.createElement(SimpleMessage, { message: statusMessage });
    }
    return (react_1.default.createElement("form", { className: "apptr__form apptr__form-auth", onSubmit: (e) => e.preventDefault() },
        react_1.default.createElement("div", { className: "apptr__form-label-container center" },
            react_1.default.createElement("div", { className: "apptr__form__label-standalone" },
                react_1.default.createElement("p", null, t('auth:pleaseChooseANewPassword'))),
            formState.error && react_1.default.createElement(FormErrors_1.default, { errors: [formState.error] })),
        react_1.default.createElement("div", { className: "apptr__form-container question-empty" },
            react_1.default.createElement("div", { className: "apptr__form-input-container" },
                react_1.default.createElement("div", { className: "apptr__form-label-container" },
                    react_1.default.createElement("label", { htmlFor: "password", className: "_flex" }, t('auth:Password'))),
                react_1.default.createElement("input", { name: "password", type: "password", id: "password", className: "apptr__form-input apptr__form-input-string apptr__input apptr__input-string", value: formState.password, onChange: handleInputChange }))),
        react_1.default.createElement("div", { className: "apptr__form-container question-empty" },
            react_1.default.createElement("div", { className: "apptr__form-input-container" },
                react_1.default.createElement("div", { className: "apptr__form-label-container" },
                    react_1.default.createElement("label", { htmlFor: "passwordConfirmation", className: "_flex" }, t('auth:PasswordConfirmation'))),
                react_1.default.createElement("input", { name: "passwordConfirmation", type: "password", id: "passwordConfirmation", className: "apptr__form-input apptr__form-input-string apptr__input apptr__input-string", value: formState.passwordConfirmation, onChange: handleInputChange }))),
        react_1.default.createElement(Button_1.default, Object.assign({}, buttonProps, { inputRef: submitButtonRef, label: t('auth:Confirm') }))));
};
exports.default = ResetPasswordPage;
//# sourceMappingURL=ResetPasswordPage.js.map